import { useTranslation } from "react-i18next";
import { BarChart3 } from "lucide-react";

interface Props {
  /** Override the default "no data" message (defaults to `reports.chart.noData`). */
  message?: string;
}

/**
 * Shared empty state for Analytics charts (TASK-3835), matching the existing
 * `ReportsTrendCard` treatment exactly: a BarChart3 icon over a muted message,
 * centered in the standard chart-height box. Per-chart tasks reuse this so the
 * "Нет данных" state is identical across the section.
 */
export function ChartEmpty({ message }: Props) {
  const { t } = useTranslation();

  return (
    <div className="flex h-56 flex-col items-center justify-center gap-2 text-gray-400">
      <BarChart3 size={28} className="text-gray-300" />
      <span className="text-sm">{message ?? t("reports.chart.noData")}</span>
    </div>
  );
}
